export const SPONSORED_BY_PREFIX_OPTIONS = [
  { label: "Paid for by", value: "Paid for by" },
  { label: "Sponsored By", value: "Sponsored By" },
  { label: "Ad from", value: "Ad from" },
];
